import {
  AppBar,
  Button,
  Flex,
  ArrowBackRoundedIcon,
  ArrowForwardRoundedIcon,
  styled,
} from '@shared/components';

const StyledButton = styled(Button)(({ theme }) => ({
  width: theme.spacing(36.5),
}));

export interface QuestionPreviewNavigationFooterProps {
  onNextQuestion: () => void;
  onBackQuestion: () => void;
  totalQuestion: number;
  currentQuestionOrder: number;
}

export default function QuestionPreviewNavigationFooter(
  props: Readonly<QuestionPreviewNavigationFooterProps>,
) {
  const { onNextQuestion, onBackQuestion, totalQuestion, currentQuestionOrder } = props;

  const isFirstQuestion = currentQuestionOrder === 1;
  const isLastQuestion = currentQuestionOrder === totalQuestion;

  return (
    <AppBar
      component='footer'
      position='sticky'
      sx={(theme) => ({
        bgcolor: theme.palette.grey[100],
        color: theme.palette.common.white,
        top: 'auto',
        bottom: 0,
      })}
    >
      <Flex
        sx={(theme) => ({
          p: theme.spacing(4, 6),
          gap: theme.spacing(4),
          alignItems: 'center',
          justifyContent: 'center',
          bottom: 0,
        })}
      >
        <StyledButton
          color='secondary'
          variant='outlined'
          size='large'
          startIcon={<ArrowBackRoundedIcon />}
          onClick={onBackQuestion}
          disabled={isFirstQuestion}
        >
          ข้อก่อนหน้า
        </StyledButton>
        <StyledButton
          color='secondary'
          variant='outlined'
          size='large'
          startIcon={<ArrowForwardRoundedIcon />}
          onClick={onNextQuestion}
          disabled={isLastQuestion}
        >
          ข้อถัดไป
        </StyledButton>
      </Flex>
    </AppBar>
  );
}
